<div class="theme_bg">
    <div class="container nopad">
        <div style="margin-block-end: 10px">
            <app-booking-steps [travellers]="true" [passengerDetails]="true" [review]="true" [ticket]="true">
            </app-booking-steps>
        </div>
    </div>
    <div class="voucher_bg" style="padding:20px; width:100%; position:relative; -webkit-print-color-adjust: exact;">
        <table id="print_voucher" #print_voucher cellpadding="0" border-collapse="" cellspacing="0" width="100%"
            *ngIf="confirmedData"
            style="font-size:12px; font-family: 'Open Sans', sans-serif; max-width:850px; border-radius: 5px; margin:10px auto;background-color:#fff; padding:20px;border-collapse:separate; color: #000;">
            <tbody style="-webkit-print-color-adjust: exact">
                <tr>
                    <td style="padding-bottom:10px">
                        <img style="width:100px;height: 40px;" src="assets/nosafer/images/l-logo.svg">
                    </td>
                    <td style="padding-bottom:10px; width: 40%;" align="right">
                        <table style="width: 100%; display:table; font-size: 13px; font-weight: 500;">
                            <tr>
                                <td>
                                    <span>Booking Reference :</span>
                                </td>
                                <td style="text-align: right;">
                                    <span [innerHTML]="confirmedData.AppReference"></span>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span>Booked on :</span>
                                </td>
                                <td style="text-align: right;">
                                    <span>{{ confirmedData.CreatedDatetime | date: 'dd/MM/yyyy' }}</span>
                                </td>
                            </tr>

                            <tr>
                                <td>
                                    <span>Last Date To Ticket :</span>
                                </td>
                                <td style="text-align: right;">
                                    <span>{{confirmedData.LastDateToTicket }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Booking Status :</span>
                                </td>
                                <td style="text-align: right;">
                                    <span>{{confirmedData.BookingStatus | map: getFormtedStatus}}</span>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td colspan="3">
                        <table
                            style="width: 100%; border-top: 1px solid #ddd;border-bottom: 1px solid #ddd; margin: 0px 0px; display: table; background-color: #fff; padding: 5px 10px;">
                            <tr>
                                <td style="padding:5px 0; font-size: 14px;">
                                </td>

                                <td style="padding:0px 0;text-align: right; font-weight: bold;">
                                    <span style="font-size:15px;">
                                        <span *ngIf="confirmedData.AIRLINEPNR != ''" style="color:#004363;padding:5px;">
                                            Airline PNR :
                                            <span style="font-size: 20px; color: #1a9ad3;">
                                                {{ confirmedData.FlightItineraries[0].airline_pnr }}
                                            </span>
                                        </span>
                                        <span *ngIf="confirmedData.AIRLINEPNR != ''" style="color:#004363;padding:5px;">
                                            GDS PNR :
                                            <span style="font-size: 20px; color: #1a9ad3;">
                                                {{ confirmedData.GDS_PNR }}
                                            </span>
                                        </span>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td style="line-height:15px;padding:0;">&nbsp;</td>
                </tr>

                <tr>
                    <td colspan="4"
                        style="border-bottom:2px solid #004363; padding:0; border-radius: 5px; overflow: hidden;">
                        <table cellspacing="0" cellpadding="5" width="100%" style="font-size:12px; padding:0;">
                            <tbody>
                                <tr>
                                    <td
                                        style="background-color:#189AD3; width: 50%; color:#fff; padding: 10px; border-right:2px solid #004363;">
                                        <span
                                            style="vertical-align:middle;font-size:17px; font-weight: 600; ">Travellers</span>
                                    </td>

                                    <td style="background-color:#189AD3; width: 50%; color:#fff; padding: 10px;">
                                        <span style="vertical-align:middle;font-size:17px; font-weight: 600;">
                                            Ticket Number
                                        </span>
                                    </td>
                                </tr>

                                <tr *ngFor="let p of confirmedData.Passengers; let i = index">

                                    <td style="padding:4px 10px; font-size: 17px; border-right:2px solid #004363;">
                                        <span><strong>{{p.title| uppercase}}.{{(p.first_name +' '+p.middle_name+' '+p.last_name |
                                                uppercase)}}</strong></span>
                                    </td>
                                    <td style="padding:4px 10px; font-size: 17px;"><span>{{p.ticket_no}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td style="line-height:15px;padding:0;">&nbsp;</td>
                </tr>
                <tr>
                    <td colspan="4" style="border-radius: 5px; padding:0;">
                        <table cellspacing="0" cellpadding="5" width="100%" style="font-size:12px; padding:0;">
                            <tbody>
                                <ng-container *ngFor="let f of confirmedData.FlightItineraries; let i = index">
                                    <tr>
                                        <td colspan="4" style="padding:0; border-bottom: 1px solid #ddd;">
                                            <table cellspacing="0" cellpadding="5" width="100%"
                                                style="font-size:12px; padding:0;">
                                                <tr><td>
                                                    <strong style="font-size: 20px; color: #004363;">{{f.from_airport_code}} - {{f.to_airport_code}} 
                                                    </strong></td>
                                                </tr>
                                                <tr>

                                                    <td colspan="3"
                                                        style="color:#004363; padding: 0px; padding-bottom: 10px; font-size: 18px; font-weight: 600;">
                                                        <img style="width: 100px;"
                                                            [src]="'./assets/airline_logo/'+ f.airline_code + '.gif'">
                                                            
                                                        &nbsp;&nbsp;&nbsp;&nbsp;
                                                        <span>
                                                            {{ f.airline_name }} | {{ f.flight_number }}
                                                        </span>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td style="width: 33.33%; padding: 0px; font-size: 14px; vertical-align: top;">
                                                        <span>
                                                            <img style="vertical-align:middle; float: left; margin-top: 5px; width: 24px;"
                                                                    src="./assets/images/departure.png">
                                                                    <strong
                                                                    style="font-size: 15px; padding-left: 10px;
                                                                    vertical-align: middle;
                                                                    float: left; width: 88%;">
                                                                <span
                                                                        style="font-weight: 500; padding-right: 10px;">
                                                                    {{f.from_airport_name}} ({{f.from_airport_code}})
                                                                </span>
                                                            </strong>
                                                            <br>
                                                            <div style="margin-left: 35px;">
                                                            {{ f.departure_datetime | date: 'EEE, d MMM y'}}
                                                            {{f.departure_datetime | date: 'HH:mm'}}
                                                            <br>
                                                            <span *ngIf="f.departure_terminal">
                                                                {{'Terminal : ' + f.departure_terminal }}
                                                            </span>
                                                            </div>
                                                            <br>
                                                        </span>
                                                    </td>

                                                    <td style="width: 33.33%; vertical-align: top;">
                                                        <span
                                                            style="display:block; font-size: 14px; padding-left:0%; text-align: center;">
                                                            <!-- Non Stop -->
                                                            <span *ngIf="f?.attributes?.Duration">{{ f?.attributes?.Duration }}</span><br>
                                                            <span *ngIf="!f?.attributes?.Duration">{{ duration(f.departure_datetime, f.arrival_datetime) }}</span><br>
                                                                Cabin Class : {{ confirmedData.CabinClass }}
                                                                <br>
                                                                <!-- {{'Aircraft : ' + f.equipment }} -->
                                                        </span>
                                                    </td>

                                                    <td
                                                            style="width: 33.33%;font-size: 14px; padding: 0px; padding-left: 0%; vertical-align: top;">
                                                        <span><img style="vertical-align:middle; float: left; margin-top: 5px; width: 25px;"
                                                            src="./assets/images/arrival.png">
                                                            <strong
                                                                    style="font-size: 15px; padding-left: 10px;
                                                                    vertical-align: middle;
                                                                    float: left; width: 88%;">

                                                                <span style="font-weight: 500; padding-right: 10px;">
                                                                    {{f.to_airport_name}} ({{ f.to_airport_code }})
                                                                </span>
                                                            </strong>
                                                            <br>
                                                            <div style="margin-left: 35px;">
                                                            {{ f.arrival_datetime | date: 'EEE, d MMM y'}}
                                                            {{f.arrival_datetime | date: 'HH:mm'}}
                                                            <br>
                                                            <span *ngIf="f.arrival_terminal">
                                                                {{'Terminal : ' + f.arrival_terminal }}
                                                            </span>
                                                        </div>
                                                        </span>
                                                    </td>

                                                </tr>
                                                <tr *ngIf="f?.attributes?.Attr?.CabinBaggage">
                                                    <td colspan="3" style="padding:6px 0px;">
                                                        <span style="font-size: 14px;">
                                                            <img style="vertical-align:top; width: 21px;"
                                                                src="./assets/images/baggage.png">
                                                            Baggage Info -
                                                            Cabin: {{f?.attributes?.Attr?.CabinBaggage | map: getBaggage}},
                                                            Check-in: {{f?.attributes?.Attr?.Baggage | map: getBaggage}}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="height:12px; line-height:0px">&nbsp;</td>
                                                </tr>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style="line-height:15px;padding:0;">&nbsp;</td>
                </tr>
                <tr>
                    <td colspan="4"
                        style="border-bottom:2px solid #004363; padding:0; border-radius: 5px; overflow: hidden;">
                        <table cellspacing="0" cellpadding="5" width="100%" style="font-size:12px; padding:0;">
                            <tbody>
                                <tr>
                                    <td colspan="2"
                                        style="background-color:#189AD3; color:#fff; padding: 10px;">
                                        <span style="vertical-align:middle;font-size:16px; font-weight: 600; ">
                                            Customer Contact Details
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="padding:4px 10px; width: 50%; font-size: 14px;"><span>
                                            E-mail : {{confirmedData.Email }}
                                        </span>
                                    </td>
                                    <td style="padding:4px 10px; width: 50%; font-size: 14px;">
                                        <span>
                                            Contact No : {{confirmedData.PhoneCode }} {{confirmedData.Phone }}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td style="line-height:15px;padding:0;">&nbsp;</td>
                </tr>

                <tr>
                    <td colspan="4" style="padding:0;border-radius: 5px;">
                        <table cellspacing="0" cellpadding="5" width="100%"
                            style="font-size:12px; padding:0; border-radius: 5px; overflow: hidden;">
                            <tbody>
                                <tr>
                                    <td width="100%" style="padding:0;border-radius: 5px; line-height: normal;">
                                        <table cellspacing="0" cellpadding="5" width="100%"
                                            style="font-size:13px; padding:0;">
                                            <tbody>
                                                <tr>
                                                    <td
                                                        style="background-color: #189AD3; color: #fff; font-size: 16px; padding: 10px;">
                                                        <span>Payment Details</span>
                                                    </td>
                                                    <td
                                                        style="background-color: #189AD3; color: #fff; font-size: 16px; padding: 10px;">
                                                        <span>Amount (
                                                            {{ confirmedData.TotalFarePriceBreakUp.Currency }}
                                                            {{ confirmedData.TotalFarePriceBreakUp.TotalDisplayFare |
                                                            number:'1.0-0'
                                                            }})
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding-left: 10px;">
                                                        <span>Air Fare</span>
                                                    </td>
                                                    <td style="padding-left: 10px;">
                                                        <span>
                                                            {{ confirmedData.TotalFarePriceBreakUp.Currency }} {{
                                                            confirmedData.TotalFarePriceBreakUp.PriceBreakup.BasicFare |
                                                            number:'1.0-0'
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding-left: 10px;">
                                                        <span>Taxes &amp; Fees</span>
                                                    </td>
                                                    <td style="padding-left: 10px;">
                                                        <span>
                                                            {{ confirmedData.TotalFarePriceBreakUp.Currency }} {{
                                                            confirmedData.TotalFarePriceBreakUp.PriceBreakup.Tax |
                                                            number:'1.1-2'
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding-left: 10px;">
                                                        <span>Convenience &amp; Fees</span>
                                                    </td>
                                                    <td style="padding-left: 10px;">
                                                        <span>
                                                            {{ confirmedData.TotalFarePriceBreakUp.Currency }} {{
                                                             confirmedData?.TotalFarePriceBreakUp?.ConvinenceFee |
                                                            number:'1.0-0'
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="padding-left: 10px;">
                                                        <span>Discount</span>
                                                    </td>
                                                    <td style="padding-left: 10px;">
                                                        <span>
                                                            {{ confirmedData.Currency }} {{
                                                            confirmedData.Discount
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <!-- <tr>
                                                    <td style="padding-left: 10px;">
                                                        <span>AIT</span>
                                                    </td>
                                                    <td style="padding-left: 10px;">
                                                        <span>
                                                            {{ confirmedData.TotalFarePriceBreakUp.Currency }} {{
                                                            confirmedData.TotalFarePriceBreakUp.PriceBreakup.AdvanceTax
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr> -->
                                                <!-- <tr>
                                                    <td style="padding-left: 10px;">
                                                        <span>Baggage</span>
                                                    </td>
                                                    <td style="padding-left: 10px;">
                                                        <span>
                                                            {{ confirmedData.TotalFarePriceBreakUp.Currency }} {{
                                                            confirmedData.TotalFarePriceBreakUp.PriceBreakup.TotalLostBaggageProtection
                                                            ||
                                                            0}}
                                                        </span>
                                                    </td>
                                                </tr> -->
                                                <tr>
                                                    <td style="border-top:1px solid #ccc; padding-left: 10px;">
                                                        <span style="font-size:18px">
                                                            Grand Total
                                                        </span>
                                                    </td>
                                                    <td style="border-top:1px solid #ccc; padding-left: 10px;">
                                                        <span style="font-size:18px; font-weight: bold;">
                                                            {{ confirmedData.TotalFarePriceBreakUp.Currency }}
                                                            {{ confirmedData.TotalFarePriceBreakUp.TotalDisplayFare |
                                                            number:'1.0-0'}}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="line-height:15px;padding:0;">&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td style="line-height:15px;padding:0;">&nbsp;</td>
                </tr>

                <tr>
                    <td colspan="4" align="middle" style="padding-top:10px; font-size: 14px; font-weight: bold;">
                        
                        Thanks for booking with nosafer
                        <br>
                        <div style="display: table;" [ngStyle]="showConfirmButtons ? '' : {'display':'none'}">
                            <br>
                            <button type="button" id="download" style="background: #189AD3;color: #fff; float:right;"
                                class="btn table-btn lg btn_hover" (click)="downloadA4('pdf', 'potrait')">
                                Download {{showConfirmTicket ? "Booking" : "Ticket"}}
                            </button>

                            <button *ngIf="showConfirmTicket" type="button" id="ticket"
                                style="background: #189AD3; float:right; margin-right: 10px; color: #fff;"
                                class="btn table-btn lg btn_hover" (click)="intitiatePayment()">
                                Confirm Ticket
                            </button>

                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>